import React, { Component } from 'react';
import Redirect from 'react-router/Redirect';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import { validateTrialToken, validateEmail, registerTrialUser } from '../actions/actions';
import apiErrors from '../modules/apierrors';
import getErrors from '../modules/geterrors';


// Taken from https://www.w3.org/TR/html5/forms.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

class TrialTokenRegistration extends Component {
  constructor() {
    super();

    this.state = {
      form: {
        token: '',
        name: '',
        email: {
          value: '',
          error: '',
        },
        password: '',
        password_confirmation: '',
      },
    };
  }

  componentWillMount() {
    if (!this.props.trialregistration.hasValidated && !this.props.trialregistration.isFetchingValidation) {
      const key = this.props.params.resetToken;
      this.props.dispatch(validateTrialToken({ key }));
    }
  }


  validateForm = (e) => {
    e.preventDefault();
    const creds = {
      key: this.props.trialregistration.trialToken.token,
      name: this.state.form.name,
      email: this.state.form.email.value,
      password: this.state.form.password,
    };

    this.props.dispatch(registerTrialUser(creds));
  }

  handleForm = (event) => {
    event.preventDefault();

    const form = { ...this.state.form };

    form.name = this.nameInput.getValue();
    form.email.value = this.emailInput.getValue();
    form.password = this.pwInput.getValue();
    form.password_confirmation = this.pw_confInput.getValue();

    const validEmail = form.email.value.match(emailRegexp);

    if (validEmail) {
      this.props.dispatch(validateEmail({ email: form.email.value }));
    }

    this.setState({ form });
  }


  renderForm = () => {
    const email = this.props.validation.email;

    const disabled = this.state.form.name.length < 2
                          || this.state.form.password.length < 6
                          || this.state.form.password_confirmation.length < 6
                          || this.state.form.password !== this.state.form.password_confirmation
                          || !email.hasFetched
                          || !email.isValid;

    const { validationErrors } = getErrors(this.props.trialregistration.errors);

    const localPassWordErrorMessage = (
      this.state.form.password.length > 6 &&
      this.state.form.password_confirmation.length > 6 &&
      this.state.form.password !== this.state.form.password_confirmation) ? 'Password confirmation does not match' : '';


    const nameErrorMessage = apiErrors[validationErrors.name] || validationErrors.name;
    const emailErrorMessage = apiErrors[validationErrors.email] || validationErrors.email;
    const passwordErrorMessage = apiErrors[validationErrors.password] || validationErrors.password || localPassWordErrorMessage;
    let emailError;

    if (!this.state.form.email.value.match(emailRegexp)) {
      emailError = 'This is not a valid email address';
    }

    if (email.hasFetched && !email.isValid) {
      emailError = 'This address is already in use';
    }
    return (
      <form>
        <h4>Register now to activate your {this.props.trialregistration.trialToken.trialDays} day free trial.</h4>
        <div>
          <p>
            {this.props.trialregistration.trialToken.description}
          </p>
        </div>
        <TextField
          errorText={nameErrorMessage}
          onChange={this.handleForm}
          ref={(input) => { this.nameInput = input; }}
          floatingLabelText="Your name"
          type="text"
          name="name"
          value={this.state.form.name}
        />
        <br />
        <TextField
          onChange={this.handleForm}
          ref={(input) => { this.emailInput = input; }}
          errorText={emailError || emailErrorMessage}
          floatingLabelText="Email"
          type="email"
          name="email"
          value={this.state.form.email.value}
        />
        <br />

        <TextField
          errorText={passwordErrorMessage}
          onChange={this.handleForm}
          ref={(input) => { this.pwInput = input; }}
          type="password"
          name="password"
          floatingLabelText="Password"
          hintText="At least 6 characters"
          value={this.state.form.password}
        /><br />
        <TextField
          onChange={this.handleForm}
          ref={(input) => { this.pw_confInput = input; }}
          type="password"
          name="password_confirmation"
          floatingLabelText="Password Confirmation"
          hintText="Match the password field"
          value={this.state.form.password_confirmation}
        /><br /><br />
        <RaisedButton
          label="Create account"
          disabled={disabled}
          primary
          onTouchTap={this.validateForm}
        />
      </form>
);
  };

  render() {
    if (this.props.auth.isAuthenticated) {
      return <Redirect to="/" />;
    }

    let content;

    const resetToken = this.props.params.resetToken || '';
    const isValidating = this.props.trialregistration.isFetchingValidation;
    const { errorMessages, validationErrors } = getErrors(this.props.trialregistration.errors);

    if (resetToken.length < 20) {
      content = <span>Faulty token...</span>;
    } else if (isValidating) {
      content = <CircularProgress size={80} thickness={5} />;
    } else if (!this.props.trialregistration.hasValidated && this.props.trialregistration.errors.length > 0) {
      content = errorMessages.map((error, index) => <span key={index}><strong>{error}</strong></span>);

      if (validationErrors.key) {
        content = <span key="key">{validationErrors.key[0]}</span>;
      }
    } else if (this.props.trialregistration.hasValidated) {
      content = this.renderForm();
    }

    return (
      <div className="unregistered" key="trialregistration">
        <Card>
          <CardHeader title="Start a free trial for Pronounce Live" />
          <CardText>
            {content}
          </CardText>
        </Card>
      </div>
    );
  }
}

export default TrialTokenRegistration;



// WEBPACK FOOTER //
// ./src/components/TrialTokenRegistration.js